if(!customElements.get('search-drawer')) {
  class SearchDrawer extends PopupModal {
    constructor() {
      super();

      this.elForm = this.querySelector('[data-search-form]');
      this.elInput = this.querySelector('[data-search-input]');
      this.elClear = this.querySelector('[data-search-clear]');
      this.elTemplate = this.querySelector('[data-search-template]');
      this.elSuggestionsTemplate = this.querySelector('[data-search-suggestions]');

      this.searchTerm = this.elInput.value;
      this.results = [];
      this.resultsCount = 0;
      this.typingTimer = null;
      this.isFetching = false;

      this.appendTemplate();

      this.elInput.addEventListener('input', () => {
        this.setAttribute('loading', !!this.elInput.value);
        this.elClear.toggleAttribute('disabled', !this.elInput.value);
      });

      this.elInput.addEventListener('keypress', () => {
        clearTimeout(this.typingTimer);
      })

      this.elInput.addEventListener('keyup', () => {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
          this.elInput.dispatchEvent(new Event('change'));
        }, 500);
      })

      this.elClear.addEventListener('click', this.clearResults.bind(this));
      this.elInput.addEventListener('change', this.setResults.bind(this));
      this.elForm.addEventListener('submit', (ev) => ev.preventDefault);
      document.addEventListener('search:close', () => this.setAttribute('open', false));
    }

    appendTemplate() {
      if(this.resultsCount == 0) {
        const emptyHeading = `
          <strong class="search-drawer--results-heading">
            0 results for "${this.searchTerm}"<br/>
            Browse popular searches below or try again.
          </strong>
        `

        this.elTemplate.innerHTML = this.searchTerm ? emptyHeading : '';
        this.elTemplate.appendChild(this.elSuggestionsTemplate.content.cloneNode(true));
        this.classList.toggle('search-performed', !!this.searchTerm);
        this.elClear.toggleAttribute('disabled', !this.searchTerm);

        this.bindSuggestions();
        document.dispatchEvent(new CustomEvent('search:loaded'));
      } else {
        this.elTemplate.innerHTML = `
          <div class="search-drawer--results">
            <strong class="search-drawer--results-heading">
              ${this.resultsCount} result${this.resultsCount > 1 ? 's' : ''} for "${this.searchTerm}"
            </strong>
            <div class="search-drawer--results-products">
              ${this.results.map(result => result).join('')}
            </div>
          </div>
        `
        this.elClear.toggleAttribute('disabled', false);
      }

      window.initLazyLoad && window.initLazyLoad();
    }

    bindSuggestions() {
      this.elSuggestions = this.querySelectorAll('[data-search-suggestion]');
      this.elSuggestions.forEach(el => el.onclick = (ev) => {
        ev.preventDefault();
        this.elInput.value = el.innerHTML.trim();
        this.elInput.dispatchEvent(new Event('change'));
      })
    }

    clearResults(ev) {
      ev.preventDefault();
      this.elClear.toggleAttribute('disabled', true);
      this.setAttribute('loading', true);
      this.searchTerm = '';
      this.results = [];
      this.resultsCount = 0;
      this.elInput.value = '';

      setTimeout(() => {
        this.appendTemplate();
        setTimeout(() => this.setAttribute('loading', false), 300);
      }, 300);
    }

    setResults(ev) {
      ev.preventDefault();
      this.elClear.toggleAttribute('disabled', false);
      this.setAttribute('loading', true);
      this.searchTerm = this.elInput.value;
      
      this.fetchResults()
        .then(data => {
          const { term, results, count } = data;
          if(term !== this.searchTerm) return;

          this.results = results;
          this.resultsCount = count;
          console.log(data);
          this.appendTemplate();
          setTimeout(() => this.setAttribute('loading', false), 300);
        })
        .catch(err => {
          console.log(err);
          this.isFetching = false;
          this.elInput.value = '';
          this.elInput.dispatchEvent(new Event('change'));
        })
    }
    
    async fetchResults() {
      const response = await fetch(`/search?q=${this.searchTerm}&type=product`);
      const data = await response.text();
      
      const html = new DOMParser().parseFromString(data, 'text/html');
      const elData = html.querySelector('[data-results-data]');
      const jsonData = JSON.parse(elData.innerHTML);

      return jsonData;
    }
  }

  customElements.define('search-drawer', SearchDrawer);
}